import React from "react";

export default function Button({ text, className, href, newTab }) {
  return (
    <div className={className}>
      <a
        className="btn btn-primary"
        href={href}
        target={newTab ? "_blank" : undefined}
        rel="noopener noreferrer"
      >
        {text}
      </a>
    </div>
  );
}
